export const LICENSE_ACTIVATION = 'activate-license';
export const ADDITIONAL_LICENSE_ACTIVATION = 'activate-additional-license';
export const VERIFY_EMAIL = 'verify-email';
